import Image from 'next/image';

import styled from '../../../../theme/styled-with-theme';
import { pxToRem } from '../../../../styles/utils';
import { mediaQueries } from '../../../../styles/media-queries';
import { BlockContainer, Layout, Column } from '../../../Layout';
import { Box } from '../../../Box';
import { Text } from '../../../Text';

export const AppBadgeContainer = styled(BlockContainer)`
  & > div {
    padding-left: ${({ theme }) => theme.spacing[0]};
  }

  ${mediaQueries[0]} {
    & > div {
      padding-right: ${({ theme }) => theme.spacing[0]};
    }
  }

  ${mediaQueries.min} {
    & > div {
      padding-right: ${({ theme }) => theme.spacing[0]};
    }
  }

  ${mediaQueries.desktop} {
    & > div {
      padding-right: ${({ theme }) => theme.spacing.sm};
    }
  }

  ${mediaQueries.max} {
    & > div {
      padding-right: ${({ theme }) => theme.spacing.l};
    }
  }
`;

export const AppBadgeLayout = styled(Layout)`
  width: fit-content;
  margin: 0 auto;

  ${mediaQueries.desktop} {
    margin-left: -${({ theme }) => theme.spacing.xs};
    width: 100%;
  }

  ${mediaQueries.max} {
    width: auto;
  }
`;

export const GoogleAppColumn = styled(Column)<{ badgeCount?: number }>`
  justify-content: ${({ badgeCount = 3 }) =>
    badgeCount > 2 ? 'flex-end' : 'center'};

  ${mediaQueries.tablet} {
    justify-content: center;
  }
`;

export const AmazonAppColumn = styled(Column)<{ badgeCount?: number }>`
  justify-content: ${({ badgeCount = 3 }) =>
    badgeCount > 2 ? 'flex-start' : 'center'};

  ${mediaQueries.tablet} {
    justify-content: center;
  }
`;

export const SpacerColumn = styled(Column)<{ hidden?: boolean }>`
  display: none;

  ${mediaQueries.tablet} {
    display: ${({ hidden = true }) => (hidden ? 'none' : 'flex')};
  }
`;

export const AppBadge = styled(Image, {
  shouldForwardProp: (prop) => prop !== 'badgeCount'
})<{ badgeCount?: number }>`
  ${mediaQueries[0]} {
    width: ${pxToRem(100)};
  }

  ${mediaQueries.min} {
    width: ${({ badgeCount = 3 }) => (badgeCount > 2 ? pxToRem(129) : '100%')};
    max-width: ${pxToRem(129)};
    min-width: ${({ badgeCount = 3 }) => (badgeCount === 1 ? pxToRem(129) : 0)};
  }

  ${mediaQueries.desktop} {
    width: 100%;
    min-width: ${pxToRem(78)};
  }

  ${mediaQueries.max} {
    width: 100%;
    max-width: ${pxToRem(112)};
    min-width: ${({ badgeCount = 3 }) => (badgeCount === 1 ? pxToRem(112) : 0)};
  }
`;

export const Logo = styled('img', {
  shouldForwardProp: (prop) => prop !== 'isAffiliate'
})<{ isAffiliate?: boolean }>`
  ${({ isAffiliate = false }) => `
    width: ${isAffiliate ? pxToRem(220) : pxToRem(204)};
  `}

  ${mediaQueries[0]} {
    width: ${pxToRem(204)};
  }

  ${mediaQueries.min} {
    width: ${pxToRem(258)};
  }

  ${mediaQueries.desktop} {
    ${({ isAffiliate = false }) => `
      width: ${isAffiliate ? pxToRem(258) : pxToRem(204)};
    `}
  }
`;

export const Tagline = styled(Text)`
  ${mediaQueries[0]} {
    font-size: ${({ theme }) => theme.fontSize.sm};
  }
`;

export const SocialIconBox = styled(Box)`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: ${pxToRem(168)};

  ${mediaQueries.min} {
    margin-left: ${({ theme }) => theme.spacing.auto}
    margin-right: ${({ theme }) => theme.spacing.auto}
  }

  ${mediaQueries.desktop} {
    margin-left: ${({ theme }) => theme.spacing[0]};
  }
`;
